import { render, staticRenderFns } from "./vocabulary.vue?vue&type=template&id=275a5fb4&scoped=true"
import script from "./vocabulary.vue?vue&type=script&lang=js"
export * from "./vocabulary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a5fb4",
  null
  
)

export default component.exports